/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { useSTR } from "react-str";
import { singleSectionStyles, responsiveStyles } from "../../commons/styles";
import { useUserContext } from "../../hooks/cookieHooks";
import { getData } from "../../utils/fetchers";
import { URL } from "../../API/urlEndpoints";
import _ from "lodash";

export const TermsConditions: React.FunctionComponent = () => {
  const user = useUserContext();
  // [GET] On page load, for fetching the details of Contracts
  const [
    ,
    {
      result: congartualtoryData,
      revalidator: refetchCongartualtoryData,
      loading: loadingCongratulatoryData,
      error: errorCongratulatoryData,
    },
  ] = useSTR(getData);

  // [GET] On Page load
  React.useEffect(() => {
    refetchCongartualtoryData(
      `${URL.getCongratulatoryDetails(_.get(user, "empId"), false)}`
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span css={[responsiveStyles]}>
      <div className="single-section" css={[singleSectionStyles()]}>
        {congartualtoryData && (
          <div className="contract-background">
            <div
              dangerouslySetInnerHTML={{
                __html: congartualtoryData && congartualtoryData.data,
              }}
            />
          </div>
        )}
        {loadingCongratulatoryData && <div className="loader" />}
        {errorCongratulatoryData && <div>Please relaod and try again</div>}
      </div>
    </span>
  );
};
